import angular from 'angular'

angular
  .module('ggs.highlighter')
  .directive('ggsHighlighter', HighlighterDirective)

function HighlighterDirective(highlighter) {
  return {
    restrict: 'E',
    link
  }

  function link($scope, $elm, $attr) {
    const source = $scope.$eval($attr.highlighterSource)
    const postInfo = $scope.$eval($attr.highlighterPostInfo)
    const positionToHashtag = $scope.$eval($attr.highlighterPositionToHashtag)
    const emojiToImg = $scope.$eval($attr.highlighterEmojiToImg)
    const userClass = $scope.$eval($attr.highlighterUserClass)
    const allowsLinks = $scope.$eval($attr.highlighterAllowsLinks)

    $elm.html(highlighter(source, postInfo, positionToHashtag, emojiToImg, userClass, allowsLinks))
  }
}
